module.exports = __webpack_public_path__ + "static/media/phone3.3f062a61.png";